<div class="form-group">
  <label for="prod-m">{{ 'form.card_withdrawal'| translate }}</label>
  <angular2-multiselect [data]="withdrawalList"
      [(ngModel)]="withdrawalSelected"
      [settings]="multiselectSettings_base"
      (onSelect)="onWithdrawalSelect()">
  </angular2-multiselect>
</div>